import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { SettingsHeader } from '../Settings';
import CommonSwitch from '../../Common/CommonSwitch';
import './../Setting.scss';
import PropTypes from 'prop-types';
import SDK from '../../../SDK';
import { PrivacySettingsAction } from '../../../../Actions/PrivacySettingsAction';
import { getConnectionStatus, dispatchErrorMessage } from '../../Common/FileUploadValidation';
import { PROFILE_HIDE, READ_RECEIPTS } from '../../../../Helpers/Chat/Constant';
import { NextArrowPrivacy } from '../../../../assets/images';
import Blocked from '../BlockedContacts';

const PrivacyToggle = React.memo(({ id, label, defaultValue, onChange }) => {
    const [isOn, setIsOn] = useState(defaultValue === 1);

    useEffect(() => {
        setIsOn(defaultValue === 1);
    }, [defaultValue]);

    const handleToggle = () => {
        // If network is not connected, prevent toggling and show error
        const conn = getConnectionStatus();
        if (conn !== 'CONNECTED') {
            // show a standard offline toast
            dispatchErrorMessage();
            return;
        }

         // Debug log
        const newValue = !isOn;
        setIsOn(newValue);
        onChange(id, newValue ? 1 : 0);
    };

    return (
        <li className="setting-list">
            <div className="setting-list-option">
                <div>
                    <div className="setting_label-text">{label}</div>
                <div className='privacy_des'>
                    {id === 'seenReceipt' ? READ_RECEIPTS : id === 'hideProfile' ? PROFILE_HIDE : ''}
                </div> </div>
                <CommonSwitch
                    id={id}
                    checked={isOn}
                    handleClick={handleToggle}
                    disabled={getConnectionStatus() !== 'CONNECTED'}
                />
            </div>
        </li>
    );
});

const PrivacySettings = ({ handleBackToSetting }) => {
    const dispatch = useDispatch();
    const privacySettingsData = useSelector(state => state.privacySettingsData);
    const [showBlocked, setShowBlocked] = useState(false);
    
    // Commented out — users/settings/privacy API is not in use
    // useEffect(() => {
    //     const fetchData = async () => {
    //         try {
    //             const response = await SDK.getUserPrivacySettings();
    //             if (response && response.statusCode === 200) {
    //                 dispatch(PrivacySettingsAction(response.privacySettings));
    //             }
    //         } catch (error) {
    //             console.error("Error fetching privacy settings:", error);
    //         }
    //     };
    //     fetchData();
    // }, [dispatch]);

    // Commented out — users/settings/privacy API is not in use
    // Updates are local-only (Redux store), no API call
    // const handleSettingChange = async (key, value) => {
    //     // Optimistic update
    //     const currentSettings = privacySettingsData?.privacySettings || {};
    //     const updatedSettings = { ...currentSettings, [key]: value };
    //
    //
    //     // We need to keep the same structure as the store expects
    //     dispatch(PrivacySettingsAction({ ...privacySettingsData, updatedSettings }));
    //
    //     try {
    //         const type = key === 'hideProfile' ? 'hide_profile' : 'seen_receipt';
    //         const action = value.toString();
    //         const response = await SDK.updateUserPrivacySettings(type, action);
    //
    //         if (response && response.statusCode === 200) {
    //           // Success - strictly speaking we could fetch again or just rely on the optimistic update
    //           // If the server returns the updated object, we could dispatch that.
    //         } else {
    //             // Revert on failure
    //             dispatch(PrivacySettingsAction(privacySettingsData));
    //             console.error('Failed to update setting.');
    //         }
    //     } catch (err) {
    //         // Revert
    //         dispatch(PrivacySettingsAction(privacySettingsData));
    //         console.error('Error updating setting:', err.message);
    //     }
    // };
    const handleSettingChange = (key, value) => {
        dispatch(PrivacySettingsAction({ ...privacySettingsData, [key]: value }));
    };

    // Safe access to nested properties with fallback to top-level
    // This handles cases where properties might be at the root (like seenReceipt in some cases) or nested
    const hideProfile = privacySettingsData?.privacySettings?.hideProfile ?? privacySettingsData?.hideProfile ?? 0;
    const seenReceipt = privacySettingsData?.privacySettings?.seenReceipt ?? privacySettingsData?.seenReceipt ?? 0;

    return (
        <>
            {!showBlocked ? (
                <div className="setting-container">
                    <div>
                        <div className="settinglist">
                            <SettingsHeader
                                label={'Privacy'}
                                handleBackFromSetting={handleBackToSetting}
                            />
                            <ul className="setting-list-ul privacy-list-ul">
                                <PrivacyToggle
                                    id="hideProfile"
                                    label="Profile Photo"
                                    defaultValue={hideProfile}
                                    onChange={handleSettingChange}
                                />
                                <PrivacyToggle
                                    id="seenReceipt"
                                    label="Read Receipts"
                                    defaultValue={seenReceipt}
                                    onChange={handleSettingChange}
                                />
                                <div className='blcoked-list-in-privacy' onClick={() => setShowBlocked(true)}>
                                    <div className="setting_label-text">Blocked Contacts</div>
                                    <div className='next_arrow_privacy'>
                                        <i className="iconNext"><NextArrowPrivacy /></i>
                                    </div>
                                </div>
                            </ul>
                        </div>
                    </div>
                </div>
            ) : (
                <Blocked handleBackToSetting={() => setShowBlocked(false)} />
            )}
        </>
    );
};

PrivacySettings.propTypes = {
    handleBackToSetting: PropTypes.func,
};

export default PrivacySettings;
